import { render, staticRenderFns } from "./RedirectToTenantStartView.vue?vue&type=template&id=084c514a&scoped=true&"
import script from "./RedirectToTenantStartView.vue?vue&type=script&lang=js&"
export * from "./RedirectToTenantStartView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c514a",
  null
  
)

export default component.exports